/* „Twój kod trenera" — the card's own line and its one control. The card, its title and its body
 * are `AccountScreen.module.css`'s `.card`, so nothing is declared on both sides.
 *
 * Every colour, space, radius and type value is a token; heights and widths are layout. */

/* The reserve. Sized before the read answers, so the skeleton bar, the code and the refusal all
 * stand in one box — the gate switches ink and never geometry. */
.codeLine {
  display: flex;
  align-items: center;
  height: var(--h-account-code);
  margin: var(--space-4) var(--space-0);
}

.code {
  font-size: var(--fs-account-code);
  font-weight: var(--fw-semibold);
  line-height: var(--lh-none);
  letter-spacing: var(--ls-eyebrow);
  color: var(--text);
  font-variant-numeric: tabular-nums;
}

.codeBar {
  width: 62%;
  height: var(--fs-h2);
}

.unavailable {
  font-size: var(--fs-label);
  font-weight: var(--fw-medium);
  color: var(--text-2);
}
